<template>
  <div class="field">
    <label class="checkbox" :for="to.id ? to.id : null">
      <input
        type="checkbox"
        :id="to.id ? to.id : null"
        v-model="model[field.key]"
        :name="field.key"
        @blur="onBlur"
        @focus="onFocus"
        @click="onClick"
        @change="onChange"
        @keyup="onKeyup"
        @keydown="onKeydown"
        v-formly-atts="to.atts"
        v-formly-input-type="to.inputType"
      />
      {{ to.label }}
    </label>
  </div>
</template>

<script>
import baseField from "./baseField";

export default {
  mixins: [baseField],
  methods: {
    onChange(e) {
      this.$set(this.form[this.field.key], "$dirty", true);
      this.runFunction("onChange", e);
    }
  }
};
</script>
